export default "__VITE_ASSET__BQTw7o0c__"